import * as yup from 'yup';

const PROCUREMENT_ORDERS_FIELDS_MAPPER = {
  id: { label: 'DB ID', key: 'id' },
  internalId: { label: 'ID', key: 'internalId' },
  createdAt: { label: 'Creation Date', key: 'createdAt' },
  stage: {
    label: 'Stage',
    key: 'stage',
    options: [
      {
        text: 'Created',
        value: 'created',
        apiKey: 1,
        styles: {
          backgroundColor: (theme) => theme.palette.fukshias.fukshia200,
          color: (theme) => theme.palette.fukshias.fukshia900,
        },
      },
      {
        text: 'Dealer Validation',
        value: 'dealer_validation',
        apiKey: 2,
        styles: {
          backgroundColor: (theme) => theme.palette.teals.teal200,
          color: (theme) => theme.palette.teals.teal900,
        },
      },
      {
        text: 'In Progress',
        value: 'in_progress',
        apiKey: 3,
        styles: {
          backgroundColor: (theme) => theme.palette.yellows.yellow200,
          color: (theme) => theme.palette.yellows.yellow900,
        },
      },
      {
        text: 'Payment Process',
        value: 'payment_process',
        apiKey: 4,
        styles: {
          backgroundColor: (theme) => theme.palette.greens.green200,
          color: (theme) => theme.palette.greens.green900,
        },
      },
      {
        text: 'Done',
        value: 'done',
        apiKey: 5,
        styles: {
          backgroundColor: (theme) => theme.palette.reds.red200,
          color: (theme) => theme.palette.reds.red900,
        },
      },
    ],
  },
  supplier: { label: 'Supplier', key: 'supplier' },
  totalPrice: { label: 'Total PO Price', key: 'totalPrice' },
};

const PROCUREMENT_ORDERS_STAGE_ORDER = [
  'created',
  'dealer_validation',
  'in_progress',
  'payment_process',
  'done',
];

const INITIAL_PROCUREMENT_ORDERS_FIELDS_GRID_COLUMNS = [
  ...Object.values(PROCUREMENT_ORDERS_FIELDS_MAPPER)
    .filter((field) => field.key !== PROCUREMENT_ORDERS_FIELDS_MAPPER.id.key)
    .map((field) => ({
      ...field,
      value: true,
    })),
];

const DEFAULT_DROPDOWN_OPTION = {
  text: '-',
  value: undefined,
};

const PROCUREMENT_ORDERS_DEFAULT_ORDER = 'asc';

const PROCUREMENT_ORDERS_DEFAULT_ORDER_BY =
  PROCUREMENT_ORDERS_FIELDS_MAPPER.createdAt.key;

const PROCUREMENT_ORDERS_PAGE_SIZE = 200;

const SUPPLIER_REQUIRED = 'Supplier is Required';

const PURCHASE_TYPE_REQUIRED = 'Purchase Type is Required';

const addProcurementOrderDefaultValues = {
  [PROCUREMENT_ORDERS_FIELDS_MAPPER.supplier.key]: '',
  sourcingType: '',
};

const PROCUREMENT_ORDER_FORM_RESOLVER = yup.object().shape({
  skuGroups: yup.array().of(
    yup.object().shape({
      vehicleDetails: yup.object().shape({
        skuId: yup.string().required('SKU is required'),
      }),
    })
  ),
});

const PROCUREMENT_ORDER_DOCUMENTS_TYPES = [
  { value: 13, text: 'Spec Sheet' },
  { value: 57, text: 'Cert' },
  { value: 58, text: 'Brochure' },
];

const PROCUREMENT_ORDER_SKU_GROUP_ITEMS_PAGE_SIZE = 100;

export {
  SUPPLIER_REQUIRED,
  PURCHASE_TYPE_REQUIRED,
  PROCUREMENT_ORDERS_FIELDS_MAPPER,
  PROCUREMENT_ORDERS_STAGE_ORDER,
  INITIAL_PROCUREMENT_ORDERS_FIELDS_GRID_COLUMNS,
  PROCUREMENT_ORDERS_PAGE_SIZE,
  PROCUREMENT_ORDERS_DEFAULT_ORDER,
  PROCUREMENT_ORDERS_DEFAULT_ORDER_BY,
  DEFAULT_DROPDOWN_OPTION,
  addProcurementOrderDefaultValues,
  PROCUREMENT_ORDER_FORM_RESOLVER,
  PROCUREMENT_ORDER_DOCUMENTS_TYPES,
  PROCUREMENT_ORDER_SKU_GROUP_ITEMS_PAGE_SIZE,
};
